module.exports = __webpack_public_path__ + "img/high.b604a28.svg";